import { useState } from 'react'
import { Card, CardContent, CardDescription } from '@/components/ui/card'

interface MermaidDiagramProps {
  readonly src: string
  readonly alt: string
  readonly caption?: string
}

export function MermaidDiagram({ src, alt, caption }: MermaidDiagramProps) {
  const [hasError, setHasError] = useState(false)

  return (
    <Card>
      <CardContent className="flex flex-col items-center gap-3 p-6">
        {hasError ? (
          <p className="text-sm text-muted-foreground">Diagram unavailable</p>
        ) : (
          <img
            src={src}
            alt={alt}
            className="w-full max-w-2xl dark:brightness-90 dark:contrast-125"
            onError={() => setHasError(true)}
          />
        )}
        {caption && (
          <CardDescription className="text-center text-xs">
            {caption}
          </CardDescription>
        )}
      </CardContent>
    </Card>
  )
}
